/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SystemVarsJobDto } from '@gh/builder-shared-data';
import { autocompleteItemToDto, withDisplayAsNameAndDescription } from '@gh/common-shared-data';
import { mergeWithPrivelegedTokens, WithOptimisticLock, WithPrivilegedToken } from '@gh/core-data';
import { isNil } from 'lodash';

export type SystemVarsJob = SystemVarsJobDto;

export type SystemVarsJobDetails = WithPrivilegedToken<WithOptimisticLock<{
  commonSettings: SystemVarsJob;
}>>;

export const systemVarsJobFromDto = (dto: SystemVarsJobDto): SystemVarsJobDetails => ({
  etag: dto.etag,
  commonSettings: {
    ...dto,
    jobCostCenter1: dto.jobCostCenter1 ? withDisplayAsNameAndDescription(dto.jobCostCenter1) : void 0,
    jobCostCenter2: dto.jobCostCenter2 ? withDisplayAsNameAndDescription(dto.jobCostCenter2) : void 0,
    jobCostCenter3: dto.jobCostCenter3 ? withDisplayAsNameAndDescription(dto.jobCostCenter3) : void 0,
    jobCostCenter4: dto.jobCostCenter4 ? withDisplayAsNameAndDescription(dto.jobCostCenter4) : void 0,
  },
});

export const systemVarsJobToDto = (details: SystemVarsJobDetails): SystemVarsJobDto => ({
  etag: details.etag,
  ...details.commonSettings,
  jobCostCenter1: isNil(details.commonSettings.jobCostCenter1) ? void 0 :
    autocompleteItemToDto(details.commonSettings.jobCostCenter1),
  jobCostCenter2: isNil(details.commonSettings.jobCostCenter2) ? void 0 :
    autocompleteItemToDto(details.commonSettings.jobCostCenter2),
  jobCostCenter3: isNil(details.commonSettings.jobCostCenter3) ? void 0 :
    autocompleteItemToDto(details.commonSettings.jobCostCenter3),
  jobCostCenter4: isNil(details.commonSettings.jobCostCenter4) ? void 0 :
    autocompleteItemToDto(details.commonSettings.jobCostCenter4),
  privilegedTokens: mergeWithPrivelegedTokens(details.commonSettings),
});
